// import { sendPasswordResetEmail } from "./action";
import { useActionData, useNavigation } from "@remix-run/react";
import { getZodConstraint, parseWithZod } from "@conform-to/zod";
import { useForm, getFormProps, SubmissionResult } from "@conform-to/react";
import { Button, RadixForm, Text, Container } from "../..";
import { FormInput } from "../../components/form-input";
import { SendResetPasswordEmailSchema } from "./schema";
import { TitleBodyContainer } from "../../components/title-body-container";

type Props = {
  email?: string; // 未ログインの場合は記入してもらう必要がある
  requestUrl?: string;
  errorDescription?: string;
  sendResetEmailActionPath: string;
};

type ActionRes = {
  submission: SubmissionResult<string[]>;
};

export const SendResetPasswordEmailForm = (props: Props) => {
  const { email, errorDescription, sendResetEmailActionPath } = props;
  // const fetcher = useFetcher();
  const actionData = useActionData<ActionRes>();
  const navigation = useNavigation();

  // async function onSubmit() {
  //   fetcher.submit({}, { method: "post", action: sendResetEmailActionPath });
  //   // if (isSubmitting) return;
  //   // e.preventDefault();
  //   // setIsSubmitting(true);
  //   // await sendPasswordResetEmail({ email, requestUrl });
  //   // setIsSubmitting(false);
  // }

  const [form, fields] = useForm({
    lastResult: actionData?.submission,
    constraint: getZodConstraint(SendResetPasswordEmailSchema),
    onValidate({ formData }) {
      return parseWithZod(formData, { schema: SendResetPasswordEmailSchema });
    },
    // defaultNoValidate: true,
    defaultValue: {
      email: "",
    },
  });

  return (
    <TitleBodyContainer
      title="パスワード再設定メールの送信"
      description="パスワードを再設定するアカウントのメールアドレスを入力してください"
      level={1}
    >
      {errorDescription && (
        <Container py="4">
          <Text color="red">{errorDescription}</Text>
        </Container>
      )}
      <RadixForm.Root
        className="px-8 py-6 bg-white rounded-lg shadow-md flex flex-col gap-4"
        {...getFormProps(form)}
        method="post"
        action={sendResetEmailActionPath}
      >
        {email ? (
          <>
            <p className="text-sm font-medium">
              以下のメールアドレスに再設定メールを送信します。
            </p>
            <p className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline">
              {email}
            </p>
          </>
        ) : (
          <>
            <FormInput
              field={fields.email}
              type="email"
              label="メールアドレス"
            />
          </>
        )}

        <RadixForm.Submit asChild>
          <Button disabled={navigation.state === "submitting"} type="submit">
            {navigation.state === "submitting"
              ? "送信中..."
              : "再設定メールを送信する"}
          </Button>
        </RadixForm.Submit>
      </RadixForm.Root>
    </TitleBodyContainer>
  );
};
